<template>
  <div class="app">
    <div v-if="$route.query.error">
      <h1>Error</h1>
      <pre>{{ $route.query }}</pre>
    </div>
    <div v-else class="app d-flex justify-content-center align-items-center">
      <h4>Connecting Xero</h4>
      <font-awesome-icon spin :icon="['fal', 'spinner']" style="font-size: 30px; margin-top: 8px" />
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  data() {
    return {};
  },
  created() {
    this.init();
  },

  methods: {
    init() {
      if (this.$route.query.code) {
        this.$http
          .put("/xero/accept", {
            code: this.$route.query.code,
            state: this.$route.query.state,
          })
          .then((response) => {
            if (response.status === 200) {
              window.toastr.info(
                `Successfully connected to Xero ${response.body.xero_organisation}`
              );

              this.$router.push({
                name: "brands.edit",
                params: { id: response.body.brand_id },
              });
            } else {
              window.toastr.error(
                "An error occurred trying to understand Xero Accept request",
                "Error"
              );
            }
          });
      }
    },
  },
};
</script>
